import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search';

const CustomAutocomplete = ({disabled, options, className, optionLabel, validation, value, onChangeTextField, onChangeAutocomplete,
                                noOptionsText, showError, getOptionSelected, inputRootSx, inputStyle, sx}) => {
    const onChange = (e, newValue) => {
        onChangeAutocomplete(newValue)
    }

    const errorMessage = () => {
        return validation ? validation : ' '
    }

    const defaultGetOptionSelected = (option, value) => option === value

    return (
        <Autocomplete
            className={className}
            disabled={disabled}
            options={options}
            onChange={onChange}
            getOptionLabel={(option) => option[optionLabel]}
            isOptionEqualToValue={getOptionSelected ? getOptionSelected : defaultGetOptionSelected }
            noOptionsText={noOptionsText}
            renderInput={(params) =>
                <TextField {...params} onChange={onChangeTextField}
                           inputProps={{...params.inputProps, style: {...params.inputProps.style, ...inputStyle}}}
                           InputProps={{...params.InputProps, sx: [params.InputProps.sx, inputRootSx], startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),}}
                   error={showError&&Boolean(validation)} helperText={showError&&errorMessage()} variant="outlined" />}
            value={value}
            sx={{
                '& .MuiInputBase-root': { paddingLeft: '10px' },
                ...sx
            }}
        />
    );
}

export default CustomAutocomplete
